
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicules-utilitaires/[slug]",
      function () {
        return require("private-next-pages/vehicules-utilitaires/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicules-utilitaires/[slug]"])
      });
    }
  